//
//
//
//
//
//

export default {
  name: "VSymbolIcon"
}
